import React from "react";
import PageHero from "../../components/pagehero/PageHero";
import Offerings from "../../components/offerings/Offerings";
import CtaBand from "../../components/ctaband/CtaBand";
import ScrollReveal from "../../components/scroll/ScrollReveal";
import "./Services.css";

const steps = [
  {
    title: "Discovery Call",
    text: "We'll discuss your needs, challenges, and goals to understand how we can best help your business.",
  },
  {
    title: "Custom Solution",
    text: "We'll create a tailored plan that addresses your specific AWS infrastructure requirements.",
  },
  {
    title: "Implementation",
    text: "Our team will execute the plan efficiently, with clear communication throughout the process.",
  },
];

const faqs = [
  {
    q: "How quickly can you start working on our AWS infrastructure?",
    a: "For most clients, we can begin work within 48 hours of signing an agreement. For urgent issues, we often provide same-day assistance.",
  },
  {
    q: "Do you require long-term contracts?",
    a: "No. Our monthly packages are month-to-month with no long-term commitment required. For project-based work, we define clear deliverables and timelines.",
  },
  {
    q: "How do you handle security and compliance?",
    a: "We implement AWS security best practices by default and have extensive experience with SOC2, HIPAA, and other compliance frameworks.",
  },
  {
    q: "What if we already have some AWS infrastructure in place?",
    a: "We'll perform a thorough assessment of your existing infrastructure and provide recommendations for improvements while working with what you already have.",
  },
];

const Services = () => {
  return (
    <React.Fragment>
      <PageHero
        eyebrow="services"
        title="AWS solutions for growing businesses"
        lede="Enterprise-grade AWS expertise at startup-friendly prices. Choose a flexible monthly package or on-demand help — whatever fits your stage."
      />

      <Offerings />

      <ScrollReveal>
        <section id="process" className="section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">how it works</p>
              <h2 className="h2">A simple three-step process</h2>
              <p className="lede">
                Getting started with TysonWorks is quick and straightforward.
              </p>
            </div>
            <div className="process-grid">
              {steps.map((step, i) => (
                <div className="process-step" key={step.title}>
                  <span className="process-number">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="h3">{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section id="faq" className="section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">faq</p>
              <h2 className="h2">Frequently asked questions</h2>
            </div>
            <div className="faq-list">
              {faqs.map((faq) => (
                <details className="faq-item" key={faq.q}>
                  <summary>
                    {faq.q}
                    <span className="faq-icon" />
                  </summary>
                  <p>{faq.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </ScrollReveal>

      <CtaBand />
    </React.Fragment>
  );
};

export default Services;
